import { register } from '../dispatcher';
import { ActionTypes } from '../constants/MogamboConstants';
import createStore from './StoreUtils.js';

const EntityStore = createStore({
  _entityDataForEdit: {},
  _entityLoadingStatus: false,
  currentBotSaysLanguage: 'en',
  currentHybridLanguage: 'en',

  /**
   * @TODO
   * @param {[type]} data [description]
   */
  setEntityData(data) {
    this._entityDataForEdit = data;
  },

  /**
   * @TODO
   * @return {[type]} [description]
   */
  getEntityData() {
    return this._entityDataForEdit;
  },

  setEntityLoadingStatus(status) {
    this._entityLoadingStatus = status;
  },

  getEntityLoadingStatus() {
    return this._entityLoadingStatus;
  },

  setCurrentBotSaysLanguage(lang) {
    this.currentBotSaysLanguage = lang;
  },

  getCurrentBotSaysLanguage() {
    return this.currentBotSaysLanguage;
  },

  setCurrentHybridLanguage(lang) {
    this.currentHybridLanguage = lang;
  },

  getCurrentHybridLanguage() {
    return this.currentHybridLanguage;
  },
});

EntityStore.dispatchToken = register((action) => {
  const actionType = action.type;
  const payload = action.action;

  switch (actionType) {
    case ActionTypes.FETCH_ENTITY_DATA_STARTED:
      EntityStore.setEntityLoadingStatus(true);
      EntityStore.emitChange();
      break;

    case ActionTypes.FETCH_ENTITY_DATA_SUCCESS:
      EntityStore.setEntityData(payload.data);
      EntityStore.setEntityLoadingStatus(false);
      EntityStore.emitChange();
      break;

    case ActionTypes.FETCH_ENTITY_DATA_FAILED:
      EntityStore.setEntityLoadingStatus(false);
      EntityStore.emitChange();
      break;

    case ActionTypes.CLEAR_ENTITY_DATA:
      EntityStore.setEntityData({});
      EntityStore.emitChange();
      break;

    case ActionTypes.UPDATE_ENTITY_DATA_STARTED:
      EntityStore.setEntityLoadingStatus(true);
      EntityStore.emitChange();
      break;

    case ActionTypes.UPDATE_ENTITY_DATA_SAVED:
      EntityStore.setEntityData(payload.data);
      EntityStore.emitChange();
      break;

    case ActionTypes.UPDATE_ENTITY_DATA_SUCCESS:
      EntityStore.setEntityData(payload.data);
      EntityStore.setEntityLoadingStatus(false);
      EntityStore.emitChange();
      break;

    case ActionTypes.UPDATE_ENTITY_LANGUAGES:
      EntityStore.setCurrentBotSaysLanguage(payload.language);
      EntityStore.setCurrentHybridLanguage(payload.hybridLanguage);
      EntityStore.emitChange();
      break;

    default:
      break;
  }
});

export default EntityStore;
